const environment = () => {
  const { hostname } = window.location;
  switch (hostname) {
    case 'nlauncher.nedigital.sg':
      return 'production';
    case 'dev-nlauncher.nedigital.sg':
      return 'preproduction';
    default:
      return undefined;
  }
};

export default {
  getName: environment
};
